import React, { Component } from "react";
import {
  loadTriggers,
  booksCategoryList,
  updateTrigger,
  addTrigger,
  deleteTrigger,
} from "../../../includes/HelperTriggers";
import { Container, Row, Col, Button, Spinner } from "react-bootstrap";
import ModalEditTrigger from "../Modals/TriggersC2/ModalEditTrigger";
import ModalAddTrigger from "../Modals/TriggersC2/ModalAddTrigger";
import TableListTriggers from "../Modals/TriggersC2/TableListTriggers";

class WhaleSaleTrigger extends Component {
  state = {
    triggers: [],
    triggerRows: [],
    showEditModal: false,
    showAddModal: false,
    editTrigger: {},
    categoryList: [],
    triggerType: 2,
    triggerBatchId: -1,
    isLoading: false,
    thisMIndex: -1,
    isTriggerEnabled: false,
    config_whalesale: {},
  };

  constructor() {
    super();
    this.onFormSubmitEditTrigger = this.onFormSubmitEditTrigger.bind(this);
    this.onFormSubmitAddTrigger = this.onFormSubmitAddTrigger.bind(this);
    this.onClickDeleteTrigger = this.onClickDeleteTrigger.bind(this);
  }

  componentDidMount() {
    /**
     * This is what executes before everything when the page loads.
     * What we're doing here:
     * 1. calling API to load/set triggers
     */
    this.setState({ triggerBatchId: this.props.triggerBatchId }, this.initiateLoadTriggers);

    if ("conf_whalesale" in this.props.batchConfiguration && this.props.batchConfiguration.conf_whalesale !== null) {
      const config_whalesale = JSON.parse(this.props.batchConfiguration.conf_whalesale);
      this.setState({ config_whalesale });
      if ("enabled" in config_whalesale) {
        this.setState({
          isTriggerEnabled: config_whalesale.enabled,
          targetDiff: config_whalesale.target_diff,
        });
      }
    }
  }

  initiateLoadTriggers() {
    this.fetchTriggers();
    this.setState({ categoryList: booksCategoryList });
  }

  /**
   * Reads Triggers from Datbase using our API and saves it to state.
   * Should we use Redux for this??
   */
  async fetchTriggers() {
    this.setState({ isLoading: true });
    const triggersList = await loadTriggers(this.props.admin_data, this.state.triggerBatchId, this.state.triggerType);
    this.setState({ triggers: triggersList, isLoading: false });
  }

  handleEditShow = (trigger, _index) => {
    let triggerClone = trigger;
    triggerClone.jsonData = JSON.parse(trigger.TriggerJson);
    let categories_id = [];
    triggerClone.jsonData.categories.forEach((category) => {
      categories_id.push(category.id);
    });
    triggerClone.catids = categories_id;
    triggerClone.categories = booksCategoryList;
    this.setState({ showEditModal: true, editTrigger: triggerClone });
  };

  /**
   * Gets called when user submits 'Edit Trigger' form from the Modal Dialog.
   * @param {formparameters} event
   */
  async onFormSubmitEditTrigger(triggerName, triggerJson) {
    // Gather required fields
    const triggerId = this.state.editTrigger.Id;

    // Call API to update trigger
    const response = await updateTrigger(
      this.props.admin_data,
      this.state.triggerBatchId,
      triggerId,
      triggerName,
      triggerJson,
      this.state.triggerType
    );
    response !== false && response.status === "success" && this.setState({ triggers: response.data });
    this.setState({ showEditModal: false });
  }

  /**
   * Gets called when user submits 'Add Trigger' form from the Modal Dialog.
   * @param {formparameters} event
   */
  async onFormSubmitAddTrigger(triggerName, triggerJson) {
    // Call API to add trigger
    const response = await addTrigger(
      this.props.admin_data,
      this.state.triggerBatchId,
      triggerName,
      triggerJson,
      this.state.triggerType
    );
    response !== false && response.status === "success" && this.setState({ triggers: response.data });
    this.setState({ showAddModal: false });
  }

  async onClickDeleteTrigger(trigger, _index) {
    // Gather required fields
    const triggerId = trigger.Id;
    // Call API to delete trigger
    const response = await deleteTrigger(
      this.props.admin_data,
      this.state.triggerBatchId,
      triggerId,
      this.state.triggerType
    );
    response !== false && response.status === "success" && this.setState({ triggers: response.data });
    this.setState({ showAddModal: false });
  }

  render() {
    let isMEnabled = false;

    if ("high_level" in this.props.batchConfiguration && this.props.batchConfiguration.high_level !== null) {
      const config_high_level = JSON.parse(this.props.batchConfiguration.high_level);
      const index = config_high_level.findIndex(function (module) {
        return module.module_name === "BookStore";
      });
      isMEnabled = config_high_level[index].enabled;
    }
    return (
      <React.Fragment>
        <ModalEditTrigger
          premiumLevel={this.props.admin_data.premium_level}
          showEditModal={this.state.showEditModal}
          categoryList={this.state.categoryList}
          handleClose={() => this.setState({ showEditModal: false })}
          onFormSubmitEditTrigger={this.onFormSubmitEditTrigger}
          editTrigger={this.state.editTrigger}
        />

        <ModalAddTrigger
          premiumLevel={this.props.admin_data.premium_level}
          showAddModal={this.state.showAddModal}
          categoryList={this.state.categoryList}
          handleClose={() => this.setState({ showAddModal: false })}
          onFormSubmitAddTrigger={this.onFormSubmitAddTrigger}
        />

        {isMEnabled === true && (
          <Container fluid={true} style={{ padding: "0" }}>
            <Row style={{ paddingBottom: "15px" }}>
              <Col md={3}></Col>
              <Col md={9} style={{ textAlign: "right" }}>
                <div style={{ textAlign: "right", marginTop: "5px" }}>
                  <Button
                    className="actionButtonLessPadding"
                    style={{ marginLeft: "8px" }}
                    variant="success"
                    onClick={() => this.setState({ showAddModal: true })}
                  >
                    Add New BookStore Trigger
                  </Button>
                </div>
              </Col>
            </Row>

            <Row style={{ marginTop: "20px" }}>
              <Col md={12}>
                {this.state.isLoading ? (
                  <div style={{ textAlign: "center", paddingTop: "100px" }}>
                    <Spinner animation="border" role="status">
                      <span className="sr-only">Loading...</span>
                    </Spinner>
                  </div>
                ) : (
                  <TableListTriggers
                    triggers={this.state.triggers}
                    categoryList={this.state.categoryList}
                    handleEditShow={this.handleEditShow}
                    deleteTrigger={this.onClickDeleteTrigger}
                  />
                )}
              </Col>
            </Row>
          </Container>
        )}
      </React.Fragment>
    );
  }
}

export default WhaleSaleTrigger;
